import { Checkbox, Stack, Typography } from '@mui/material'
import { TimepointContainerSubmissionExamMetadata } from '@common/config/api/client'
import { SPACING } from '@common/theme/spacing'
import { ContainerParam } from '@features/subject/subject.types'
import { formatExamAcquisitionDate } from './formatExamAcquisitionDate'

export default function ReassignExamDetails({
  container,
  exam,
  isSelected = false,
  onSelectionChange,
}: {
  container: ContainerParam
  exam: TimepointContainerSubmissionExamMetadata
  isSelected?: boolean
  onSelectionChange?: (examId: string, isSelected: boolean) => void
}) {
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (exam.exam_metadata_id && onSelectionChange) {
      onSelectionChange(exam.exam_metadata_id, event.target.checked)
    }
  }

  return (
    <Stack
      direction="row"
      spacing={SPACING.examDetailsSpacing}
      alignItems="center"
      justifyContent="space-between"
      paddingX={SPACING.examDetailsSpacing}
      paddingY={SPACING.minSpacing}
    >
      <Stack>
        <Checkbox
          color="primary"
          checked={isSelected}
          onChange={handleCheckboxChange}
          disabled={!exam.exam_metadata_id}
          name="exam-checkbox"
        />
      </Stack>
      <Stack spacing={SPACING.examDetailsTypographySpacing}>
        <Typography
          sx={{
            color: 'text.secondary',
          }}
          variant="subtitle2"
        >
          Modality
        </Typography>
        <Typography variant="body2">{container.modality}</Typography>
      </Stack>
      <Stack spacing={SPACING.examDetailsTypographySpacing}>
        <Typography
          sx={{
            color: 'text.secondary',
          }}
          variant="subtitle2"
        >
          Study description
        </Typography>
        <Typography variant="body2">{exam.study_description}</Typography>
      </Stack>
      <Stack spacing={SPACING.examDetailsTypographySpacing}>
        <Typography
          sx={{
            color: 'text.secondary',
          }}
          variant="subtitle2"
        >
          Date
        </Typography>
        <Typography variant="body2">{formatExamAcquisitionDate(exam.acquisition_date)}</Typography>
      </Stack>
    </Stack>
  )
}
